import { createAction, props } from '@ngrx/store';
import { BroadCastAction } from '../services/broadcast.service';
import { BroadCastListenerPayload } from '../types';

export const BroadCastEvent = createAction(
  '[BroadCast] Broadcast Event',
  props<{ payload: BroadCastAction }>(),
);

export const BroadCastListener = createAction(
  '[Broadcast] Broadcast Listener',
  props<BroadCastListenerPayload<any>>(),
);
